import { useSessionStorage } from "@uidotdev/usehooks";
import * as React from "react";

export const TestModeContext = React.createContext<{
  setTestMode: React.Dispatch<React.SetStateAction<boolean>>;
  testMode: boolean;
}>({
  setTestMode: () => {},
  testMode: false,
});

export const TestModeProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }: { children: React.ReactNode }) => {
  const [testMode, setTestMode] = useSessionStorage("testMode", false);

  return (
    <TestModeContext.Provider value={{ testMode, setTestMode }}>
      {children}
    </TestModeContext.Provider>
  );
};

export const useTestMode = () => {
  const contextValue = React.useContext(TestModeContext);
  if (!contextValue)
    throw new Error("useTestMode must be used within a TestModeProvider");
  return contextValue;
};
